/*
 * Purpose: Render left panel for branding in Access Shell layout.
 * Boundary: Displays static branding content; hidden when legal guardian panel is visible.
 * Invariants:
 * - ASCII only; no Unicode in comments or strings.
 */
import React from 'react';

// Component AccessShellLeftPanelLayout:
export default function AccessShellLeftPanelLayout() {
    return (
        <div className="relative h-full md:col-span-1">
            <div>
                {/*<h1 className="text-xl font-semibold">Secure Digital Certification Platform</h1>*/}
                <p className="text-neutral-400">
                    Smart ID, Driver's Licence, Passport, and Proof of Address certified online.
                </p>
                <p className="text-neutral-400">
                    Powered by Beantech (Pty) Ltd
                </p>
            </div>
            <div>
                <img
                    alt=""
                    className="py-10 object-contain mix-blend-screen"
                    src="/assets/images/oaths-logo.png"
                />
            </div>
        </div>
    );
}